import { create } from 'zustand'

import { storeFutuUserInfo } from './userInfo'
import { debounce } from '../utils/feature'

import { RefObject } from 'react'
import { FUTU_listenKey } from '@/entities/futures/api/futuApiKey'

// 가끔 벨런스가 변경될때 처리하면 됨
const ChangeFutuBalance = (data: AccountUpdateEvent) => {
  const balances = data.a.B.filter((el) => el.a === 'USDT')
  if (balances.length > 0) {
    if (balances[0].bc !== '0') {
      storeFutuUserInfo.getState().setWSBalances({ a: balances[0].a, wb: balances[0].wb, cw: balances[0].cw })
    }
  }
}

const EventBinanceUser = (message: string) => {
  const data = JSON.parse(message)
  switch (data.e) {
    case 'ACCOUNT_UPDATE':
      if (data.a.m === 'ORDER') {
        // 포지션 업데이트
        storeFutuWSUser.getState().LISTEN_ORDER(data as AccountUpdateEvent)
        // order 에도 벨런스가 존재하지만 딱히 변경되지 않기 때문에 문제는 없음
      } else if (data.a.m === 'INSURANCE_CLEAR') {
        storeFutuWSUser.getState().LISTEN_INSURANCE_CLEAR(data as AccountUpdateEvent)
      } else if (data.a.m === 'MARGIN_TRANSFER') {
        // 마진 업데이트
        storeFutuWSUser.getState().LISTEN_MARGIN_TRANSFER(data as AccountUpdateEvent)
      } else if (data.a.m === 'MARGIN_TYPE_CHANGE') {
        // 마진 타입 변경
        storeFutuWSUser.getState().LISTEN_MARGIN_TYPE_CHANGE(data as AccountUpdateEvent)
      }

      // else if (data.a.m === 'DEPOSIT' || data.a.m === 'WITHDRAW' || data.a.m === 'ADMIN_WITHDRAW') {
      //   // 출금
      //   storeFutuWSUser.getState().LISTEN_BALANCE_UPDATE(data as AccountUpdateEvent)
      // }

      // 변경이 된거라고 생각하면 무조건 하면 됨. 어자피 콜하는것도 없으니까 문제는 없겠지.
      ChangeFutuBalance(data)

      break
    case 'ORDER_TRADE_UPDATE': // 주문 변경시
      // 주문 정보 업데이트 처리 가능
      storeFutuWSUser.getState().LISTEN_ORDER_TRADE_UPDATE(data as OrderTradeUpdateEvent)
      break
    case 'listenKeyExpired': // 만료 됐기때문에 재요청해야됨 .
      // 재연결
      storeFutuWSUser.getState().LISTEN_KEY_EXPIRED()
      break
    case 'ALGO_UPDATE': // 알고 주문 변경시
      storeFutuWSUser.getState().LISTEN_ALGO_UPDATE(data as AlgoUpdateEvent)
      break
    default:
      console.log('Unknown event type:', data.e)
  }
}

interface BinanceWsUserTestData {
  userListenKey: string
  userSocket: RefObject<WebSocket | null>
  isConnected: boolean

  connect: () => void
  unConnect: () => void

  // Account_update
  LISTEN_ORDER: (data: AccountUpdateEvent) => void
  LISTEN_INSURANCE_CLEAR: (data: AccountUpdateEvent) => void
  LISTEN_MARGIN_TRANSFER: (data: AccountUpdateEvent) => void
  LISTEN_MARGIN_TYPE_CHANGE: (data: AccountUpdateEvent) => void
  LISTEN_BALANCE_UPDATE: (data: AccountUpdateEvent) => void
  // Order_Trade_update
  LISTEN_ORDER_TRADE_UPDATE: (data: OrderTradeUpdateEvent) => void
  LISTEN_ALGO_UPDATE: (data: AlgoUpdateEvent) => void

  // Account_config_update
  LISTEN_ACCOUNT_CONFIG_UPDATE_Leverage: (data: AccountConfigUpdateEvent) => void
  LISTEN_ACCOUNT_CONFIG_UPDATE_AI: (data: AccountConfigUpdateEvent) => void // 헷지모드 변경시, 사용은 안함

  // listenKeyExpired
  LISTEN_KEY_EXPIRED: () => void
}

// 주기적으로 끊었다가 연결할 필요가 있음.
export const storeFutuWSUser = create<BinanceWsUserTestData>((set, get) => ({
  userListenKey: '',
  userSocket: { current: null } as RefObject<WebSocket | null>,
  isConnected: false,
  connect: async () => {
    const { userSocket, isConnected } = get()

    // 로그인 처리 안되어 있으면 실행하지 말어..

    if (get().userListenKey == '') {
      // 바이낸스에 요청해서 key 받아오기
      const result = await FUTU_listenKey()
      set({ userListenKey: result.listenKey })
    }

    if (isConnected && userSocket.current) {
      console.warn('[WS FuturesUser] is already connected')
      return
    }

    const url = `wss://fstream.binance.com/ws/${get().userListenKey}`
    const socket = new WebSocket(url)
    socket.onopen = () => {
      console.log('[WS FuturesUser] connected')
      set({ isConnected: true })
    }

    socket.onclose = () => {
      console.log('[WS FuturesUser] closed')
      set({ isConnected: false })
      get().userSocket.current = null
    }

    socket.onerror = (error) => {
      console.error('[WS FuturesUser] error:', error)
    }

    socket.onmessage = (event) => {
      EventBinanceUser(event.data)
    }

    get().userSocket.current = socket
  },

  unConnect: async () => {
    const socket = get().userSocket?.current

    if (socket) {
      // WebSocket 연결 종료
      socket.close()

      // 이벤트 리스너 해제
      socket.onclose = null
      socket.onerror = null
      socket.onmessage = null
      socket.onopen = null

      // 상태 업데이트: 연결 종료 및 초기화
      set({
        userListenKey: '',
        userSocket: { current: null },
        isConnected: false,
      })
      console.log('[WS FuturesUser] unconnected')
    }
  },
  LISTEN_ORDER: (data: AccountUpdateEvent) => {
    try {
      // console.log('LISTEN_ORDER', data)
      // 포지션 업데이트
      storeFutuUserInfo.getState().setWSPosition(data)
    } catch (e) {
      console.log(e)
    }
  },
  LISTEN_INSURANCE_CLEAR: (data: AccountUpdateEvent) => {
    // console.log('LISTEN_INSURANCE_CLEAR', data)
    // 청산됐으니까 모두 초기화
    storeFutuUserInfo.getState().setBalancesAPI()
    storeFutuUserInfo.getState().setWSPosition(data)
  },
  LISTEN_MARGIN_TRANSFER: (data: AccountUpdateEvent) => {
    // console.log('LISTEN_MARGIN_TRANSFER', data)
    // 마진 추가 한거고,  position 이 변경되어서 청산가가 늘어나야 되는 상황
    // 이건 계산을 가능할텐데... 한개인까?.
    // storeFutuUserInfo.getState().setBalancesAPI()
    data.a.B.forEach((el) => {
      if (el.a === 'USDT') {
        storeFutuUserInfo.getState().setWSBalances({ a: el.a, wb: el.wb, cw: el.cw })
      }
    })

    storeFutuUserInfo.getState().setWSPosition(data)
  },
  LISTEN_MARGIN_TYPE_CHANGE: (data: AccountUpdateEvent) => {
    // console.log('LISTEN_MARGIN_TYPE_CHANGE', data)

    // Extract the margin type from the position data
    const positions = data.a.P
    if (positions && positions.length > 0) {
      const marginType = positions[0].mt // Get the margin type from the first position
      const symbol = positions[0].s // Get the symbol from the first position

      // Update the margin type in storeFutuUserInfo store
      // storeFutuUserInfo.getState().setWSMarginType(symbol, marginType);
      // console.log(`Margin type changed for ${symbol}: ${marginType}`)

      storeFutuUserInfo.getState().setWSMarginTypeChange(symbol, marginType)
    } else {
      // console.log('No position data found in MARGIN_TYPE_CHANGE event')
    }
  },
  LISTEN_BALANCE_UPDATE: (data: AccountUpdateEvent) => { },
  LISTEN_ORDER_TRADE_UPDATE: debounce((data: OrderTradeUpdateEvent) => {
    console.log('LISTEN_ORDER_TRADE_UPDATE', data)
    storeFutuUserInfo.getState().setWSOpenOrder(data)
  }, 300),
  LISTEN_ALGO_UPDATE: (data: AlgoUpdateEvent) => {
    // console.log('LISTEN_ALGO_UPDATE', data)
    storeFutuUserInfo.getState().setWSAlgoOrder(data)
  },
  LISTEN_ACCOUNT_CONFIG_UPDATE_Leverage: (data: AccountConfigUpdateEvent) => {
    // console.log('LISTEN_ACCOUNT_CONFIG_UPDATE_Leverage', data)

    // LISTEN_ACCOUNT_CONFIG_UPDATE_Leverage
    if (data?.ac?.s === undefined || data.ac.l === undefined) {
      return
    }

    if (data?.ac?.s === null || data.ac.l === null) {
      return
    }

    storeFutuUserInfo.getState().setWSLeverage(data.ac.s, Number(data.ac.l.toString()))
  },
  // 헷지모드 변경시 .. 사용하지 않음
  LISTEN_ACCOUNT_CONFIG_UPDATE_AI: (data: AccountConfigUpdateEvent) => {
    // console.log('LISTEN_ACCOUNT_CONFIG_UPDATE_AI', data)
  },

  // 키 만료시 재연결 요청
  LISTEN_KEY_EXPIRED: () => {
    console.log('LISTEN_KEY_EXPIRED')
    set({ userListenKey: '' }, false)

    get().unConnect()
    get().connect()
  },
}))
